import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import "../style/calendario.css";
import { api } from "../api/api";

const CalendarPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [eventos, setEventos] = useState([]);


    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState("create");
    const [titulo, setTitulo] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);


    useEffect(() => {
        const fetchEventos = async () => {
            try {
                const res = await api.getEventos();
                if (res.success) {
                    setEventos(
                        res.eventos.map((e) => ({
                            id: e.id,
                            title: e.titulo,
                            start: e.fecha_inicio,
                            end: e.fecha_fin,
                            extendedProps: { descripcion: e.descripcion },
                        }))
                    );
                }
            } catch (err) {
                console.error("❌ Error obteniendo eventos:", err);
            }
        };
        fetchEventos();
    }, []);


    const handleDateClick = (info) => {
        setModalMode("create");
        setTitulo("");
        setSelectedDate(info.dateStr);
        setShowModal(true);
    };

    const handleSaveEvento = async () => {
        if (!titulo.trim()) return;
        if (modalMode === "create") {
            const nuevoEvento = {
                titulo,
                descripcion: "",
                fecha_inicio: selectedDate,
                fecha_fin: selectedDate,
            };
            const res = await api.addEvento(nuevoEvento);
            if (res.success) {
                setEventos([...eventos, { id: res.id, title: titulo, start: selectedDate, end: selectedDate }]);
            }
        }
        if (modalMode === "edit") {

            const res = await api.updateEvento(selectedEvent.id, { titulo });
            if (res.success) {
                setEventos(eventos.map(ev => ev.id === selectedEvent.id ? { ...ev, title: titulo } : ev));
            }
        }
        setShowModal(false);
    };


    const handleEventClick = (info) => {
        setModalMode("edit");
        setSelectedEvent({ id: parseInt(info.event.id), title: info.event.title });
        setTitulo(info.event.title);
        setShowModal(true);
    };


    const handleDeleteEvento = async () => {
        if (!selectedEvent) return;
        const res = await api.deleteEvento(selectedEvent.id);
        if (res.success) {
            setEventos(eventos.filter((ev) => ev.id !== selectedEvent.id));
            setShowModal(false);
        }
    };

    return (
        <div className="dashboard-root dashboard-dark">
            <div className="sidebar-container">
                <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
            <div className="dashboard-main">
                <Header isOpen={isOpen} setIsOpen={setIsOpen} />
                <div className="dashboard-content">
                    <div className="dashboard-card dashboard-card-dark" style={{ padding: "1rem" }}>
                        <h3>Calendario de Eventos</h3>
                        <FullCalendar
                            plugins={[dayGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            events={eventos}
                            dateClick={handleDateClick}
                            eventClick={handleEventClick}
                            locales={[esLocale]}
                            locale="es"
                            height="80vh"
                        />
                    </div>
                </div>
            </div>


            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>{modalMode === "create" ? "Nuevo evento" : "Editar evento"}</h3>
                        <input
                            type="text"
                            placeholder="Título del evento"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                        <div className="modal-actions">
                            {modalMode === "edit" && (
                                <button onClick={handleDeleteEvento} style={{ background: "#e53935", color: "#fff" }}>
                                    Eliminar
                                </button>
                            )}
                            <button onClick={() => setShowModal(false)}>Cancelar</button>
                            <button onClick={handleSaveEvento}>Guardar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalendarPage;
